import $ from 'jquery';
import 'jquery.easing';

function init() {
  menuOpen();
}

function menuOpen() {
  const $btn = $('#l-header__burger');
  const $menu = $('#l-header__nav');

  if (!$btn[0]) {
    return;
  }

  const type = $btn.attr('data-type');

  $btn.on('click', () => {
    if (!$btn.hasClass('-active')) {
      $btn.addClass('-active');

      if (type === 'class') {
        $menu.addClass('-active');
      } else {
        $menu.fadeIn();
      }
      $('body').addClass('-fixed');
    } else {
      $btn.removeClass('-active');

      if (type === 'class') {
        $menu.removeClass('-active');
      } else {
        $menu.fadeOut();
      }
      $('body').removeClass('-fixed');
    }
  });
}

export default {
  init,
};
